import { Row, Container } from 'react-bootstrap';

function PageHeader({title, subtitle}) {

    const Subtitle = () => {
        if (subtitle) {
            return (
                <h3>{subtitle}</h3>
            )
        }
        return null;
    };

    return (
        <Row>
            <Container className='page-header'>
                <h1>{title}</h1>
                <Subtitle />
                </Container>
        </Row>
    )
}

export default PageHeader; 